import React from "react";
import './SkillsFolder.css'
import SkillsIcon from "../SkillsIcon/SkillsIcon";
import htmlLogo from "../../images/html.png"
import cssLogo from "../../images/css.png"
import javascriptLogo from "../../images/javascript.png"
import reactLogo from "../../images/react.png"
import nodeLogo from "../../images/nodejs.png"
import expressLogo from "../../images/express.png"
import postgreLogo from "../../images/postgresql.png"
import cLogo from "../../images/c++.png"
import gitLogo from "../../images/git.png"
import javaLogo from "../../images/java.webp"
import mysqlLogo from "../../images/mysql.png"

const SkillsFolder = () => {
    return(
        <div className="skillsFolder">
            <SkillsIcon text={"HTML"} img={htmlLogo}/>
            <SkillsIcon text={"CSS"} img={cssLogo}/>
            <SkillsIcon text={"JavaScript"} img={javascriptLogo}/>
            <SkillsIcon text={"React.JS"} img={reactLogo}/>
            <SkillsIcon text={"Node.JS"} img={nodeLogo}/>
            <SkillsIcon text={"Express"} img={expressLogo}/>
            <SkillsIcon text={"PostgreSQL"} img={postgreLogo}/>
            <SkillsIcon text={"MySQL"} img={mysqlLogo}/>
            <SkillsIcon text={"C++"} img={cLogo}/>
            <SkillsIcon text={"Java"} img={javaLogo}/>
            <SkillsIcon text={"Git"} img={gitLogo}/>
        </div>
    )
}

export default SkillsFolder